import Image from "next/image";
import {displayFromTime} from "../../../utilities/helper";
import Slider from "react-slick";
import StarList from "components/shop/review/starList";

export default function Index({ review}){
    const settingsDetail = {
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        adaptiveHeight: true,
    };
    const genRating = (w,h,rate)=>{
        return [1,2,3,4,5].map(item => {
            if ( item <= (rate || 0) ) {
                return(<li key={item} style={{display:"flex"}}>
                    <Image width={w} height={h} className="svg" src="/images/icon-star.svg" alt=""/></li>);
            }else {
                return(<li key={item} style={{display:"flex"}}>
                    <Image width={w} height={h} className="svg" src="/images/icon-star-gray.svg" alt=""/></li>);
            }
        });
    };

    const genMedia = (media)=>{
        return media?.map((k,index) =>{
            return(
                <div key={index}>
                    <div className="photo wrap-next-image">
                        <Image width={81} height={81} src={k || "/images/img-sale01.png"} align="" alt=""/>
                    </div>
                </div>
            );
        });
    };
    const genCommentList = review?.map((item,index) =>{
        return(
            <div className="comment-group" key={index}>
                <div className="comment-user">
                    <div className="comment-info">
                        <div className="comment-info_thumb">
                            <Image width={40} height={40} src={item?.avatar || "https://happynest.vn/home2017-assets/avatar-happynest@2x.png"} alt=""/>
                        </div>
                        <div className="comment-info_text">
                            <p className="name">{item?.nickname}</p>
                            <StarList number={item?.ratings[0]?.value}/>
                        </div>
                    </div>
                    {/*<div className="comment-name">*/}
                    {/*    <p className="text">Người mua hàng</p>*/}
                    {/*</div>*/}
                </div>
                <div className="comment-slider">
                    <div className="slider sliderPhoto">
                        <Slider {...settingsDetail}>
                            {genMedia(item?.media)}
                        </Slider>
                    </div>
                </div>
                <div className="cmt-user">
                    <div className="comment-content">
                        <div className="comment-txt">
                            <p>{item?.detail}</p>
                        </div>
                        <div className="comment-tools">
                            <ul className="cmt-tools">
                                <li className="time">{ displayFromTime(item?.created_at)}</li>
                                {/*<li className={"like like-active " + ( logined ? "" : "d-none")}>Thích</li>*/}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        );
    });
    return(
        <div className="comment">
            { genCommentList}
        </div>
    );
};